module.exports = __webpack_public_path__ + "factorContributionsToRiskTrend.d7a67c7df77992606dcf45712662eb62.png";